<template>
  <div class="container-fluid" style="padding-left: 0px; padding-right: 0px;">
    <div class="pageContainer">
      <div class="row">
        <div class="col-sm-9">
          <div class="pageSubContainer">
            <div class="row">
              <div class="col-sm-1"></div>
              <div class="col-sm-10">
                <div class="row">
                  <div class="col-sm-12">
                    <h2>Asset Details</h2>
                  </div>
                </div>
                <form @submit.prevent="editAsset">
                <div class="row">
                  <div class="col-sm-4">
                    <label>Name</label>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" class="text" v-model="asset.name" />
                  </div>
                </div>
                
                <div class="row">
                  <div class="col-sm-4">
                    <label>Make</label>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" class="text" v-model="asset.make" />
                  </div>
                </div>
               
                <div class="row">
                  <div class="col-sm-4">
                    <label>Model</label>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" class="text" v-model="asset.model" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <label>Serial</label>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" class="text" v-model="asset.serial" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <label>Type</label>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" class="text" v-model="asset.type" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <label>Year Installed</label>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" class="text" v-model="asset.year_installed" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <label>Site Address</label>
                  </div>
                  <div class="col-sm-8">
                    <div class="commerceSelect">
                      <select v-model="asset.address_id">
                        <option v-for="address in addresses" :key="address.id" :value="address.id" :selected="address.id === asset.address_id">({{ address.label }}) {{ address.address1 }}, {{ address.address2 }}, {{ address.city }}, {{ address.county }}, {{ address.postcode }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <label>Test Frequency</label>
                  </div>
                  <div class="col-sm-8">
                    <div class="commerceSelect">
                      <select v-model="asset.test_frequency">
                        <option value="5 to 50 tonnes CO2">5 to 50 tonnes CO2</option>
                        <option value="50 to 500 tonnes CO2">50 to 500 tonnes CO2</option>
                        <option value="Above 500 tonnes">Above 500 tonnes</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <label>Fixed Detection System</label>
                  </div>
                  <div class="col-sm-8">
                    <label class="checkboxContainer"><input type="checkbox" v-model="asset.detection" :true-value="1"
                      :false-value="0"><span class="checkmark"></span></label>
                  </div>
                </div>
                
                <div class="row" style="margin-top:30px;">
                  <div class="col-sm-12">
                    <hr />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <label>Refrigeration Type</label>
                  </div>
                  <div class="col-sm-8">
                    <div class="commerceSelect">
                      <select v-model="asset.refrigeration_type">
                        <option value="R449A">R449A</option>
                        <option value="R452A">R452A</option>
                        <option value="R404A">R404A</option>
                        <option value="R32">R32</option>
                        <option value="R410A">R410A</option>
                        <option value="R134A">R134A</option>
                        <option value="R290">R290</option>
                        <option value="R600">R600</option>
                        <option value="6407C">6407C</option>
                        <option value="R407F">R407F</option>
                        <option value="R448A">R448A</option> 
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <label>Refrigeration Quantity (Kg)</label>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" class="text" v-model="asset.refrigeration_quantity_kg" readonly />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <label>GWP</label>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" class="text" v-model="asset.gwp" readonly />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    <label>CO2</label>
                  </div>
                  <div class="col-sm-8">
                    <input type="text" class="text" v-model="asset.c02" readonly />
                  </div>
                </div>
                <div class="row" style="margin-top:30px;">
                  <div class="col-sm-12">
                    <hr />
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-4">
                    
                  </div>
                  <div class="col-sm-8">
                    <button type="submit" name="submit">Save Asset</button>
                  </div>
                </div>
                </form>
              </div>
              <div class="col-sm-1"></div>
            </div>
          </div>
        </div>
        <div class="col-sm-3"></div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      asset: {},
      addresses: {},
    }
  },
  created () {
    axios
      .get(`/api/assets/${this.$route.params.id}`)
      .then((res) => {
        this.asset = res.data

        axios
          .get(`/api/companies/${this.asset.company_id}/addresses`)
          .then(response => {
            this.addresses = response.data
          })

      })
  },
  methods: {
    editAsset () {
      axios
        .put(`/api/assets/${this.$route.params.id}`, this.asset)
        .then(response => (
          this.$toast.success("Asset saved", {}),
          this.$router.push({ name: 'AssetsJobs', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    }
  }
}
</script>
